import type { CardholderOnboardingTranslations } from "../interfaces/cardholderOnboarding";

export const cardholderOnboardingTranslations: CardholderOnboardingTranslations = {
  page_title: "Alta de titulares",
  page_subtitle:
    "Lleva a cada titular de una organización desde su registro hasta poder tener tarjeta. Cada fila dice dónde está y qué hacer.",
  action_refresh: "Actualizar",
  retry: "Reintentar",
  cancel: "Cancelar",
  close: "Cerrar",
  unnamed: "Sin nombre",
  provider_unknown: "el emisor de tarjetas",
  error_generic: "No pudimos completar la acción. Vuelve a intentar en un momento.",

  scope_label: "Organización",
  scope_placeholder: "Busca por nombre, correo o ID",
  scope_loading: "Cargando organizaciones…",
  scope_empty: "Ninguna organización coincide",
  scope_searching: "Buscando…",
  scope_search_error: "No pudimos buscar organizaciones",
  scope_catalog_error: "No pudimos cargar las organizaciones",
  scope_catalog_truncated: "Solo se muestran las más recientes; escribe para buscar las demás",
  scope_required_hint: "Elige la organización cuyos titulares quieres revisar",
  scope_org_hint: "Titulares de esta organización",
  summary_line: "{{name}} · emite con {{provider}} · {{count}} titulares",

  pick_org_title: "Elige una organización",
  pick_org_description:
    "Verás a cada uno de sus titulares, en qué paso está y qué le falta para tener tarjeta.",
  load_error: "No pudimos cargar los titulares de esta organización.",
  denied_error: "Tu usuario no tiene permiso para ver los titulares.",
  unsupported_notice:
    "Esta organización emite con {{provider}}: sus titulares se registran al crearlos, así que aquí solo se reintentan los registros que fallaron.",
  truncated_notice: "La organización tiene más de 2.000 titulares; solo se muestran los más recientes.",

  bucket_ready: "Listos para enviar",
  bucket_paused: "En pausa",
  bucket_needs_verification: "Sin verificación",
  bucket_needs_data: "Faltan datos",
  bucket_registration_failed: "Registro fallido",
  bucket_in_progress: "En proceso",
  bucket_enabled: "Habilitados",
  bucket_closed: "Cerrados",

  search_placeholder: "Busca por nombre, documento o correo",
  clear_filters: "Ver todos",
  empty_organization: "Esta organización no tiene titulares todavía",
  empty_bucket: "No hay titulares en este grupo",
  empty_search: "Ningún titular coincide con «{{term}}»",

  column_holder: "Titular",
  column_progress: "Avance",
  column_next: "Siguiente paso",
  own_identity_badge: "La organización",
  select_page: "Seleccionar los de esta página",
  select_row: "Seleccionar a {{name}}",
  bulk_selected: "Seleccionados: {{count}}",
  bulk_clear: "Quitar selección",
  bulk_send: "Enviar a {{provider}}",

  track_label: "Avance del titular",
  step_registration: "Registro",
  step_verification: "Verificación",
  state_done: "listo",
  state_current: "en curso",
  state_blocked: "detenido",
  state_failed: "falló",
  state_pending: "pendiente",

  headline_ready: "Verificado y listo para enviar a {{provider}}.",
  headline_ready_resume: "Verificado; quedó a medias en {{provider}} y se puede reanudar.",
  headline_paused: "En pausa en {{provider}}.",
  headline_paused_reason: "En pausa en {{provider}}: {{reason}}.",
  headline_verification_missing: "No tiene una verificación de identidad vinculada.",
  headline_verification_not_approved: "Su verificación no figura aprobada.",
  headline_verification_other_service:
    "Su verificación se hizo con otro servicio de identidad; no se puede enviar desde aquí.",
  headline_verification_incomplete:
    "Su registro de verificación está incompleto; revísalo con el equipo técnico.",
  headline_missing_email: "La organización no tiene un correo de esta persona.",
  headline_missing_identity_fields: "Le falta el apellido o la fecha de nacimiento.",
  headline_registration_failed: "Su registro como titular no terminó.",
  headline_in_progress: "{{provider}} lo está procesando.",
  headline_in_review: "{{provider}} está revisando sus documentos.",
  headline_enabled: "Habilitado: ya puede tener tarjetas.",
  headline_identity_rejected: "Su identidad fue rechazada.",
  headline_card_rejected: "{{provider}} rechazó su alta.",
  headline_business: "Es una empresa: {{provider}} solo da tarjetas a personas.",
  headline_closed: "No hay nada que hacer con este titular.",

  action_send: "Enviar",
  action_resume: "Reanudar",
  action_link_verification: "Vincular verificación",
  action_sync_verification: "Revisar verificación",
  action_complete_data: "Ver qué falta",
  action_retry_registration: "Reintentar registro",

  skip_already_enabled: "Ya está habilitado",
  skip_already_rejected: "Su alta fue rechazada",
  skip_no_kyc_record: "No tiene verificación de identidad",
  skip_kyc_not_verified: "Su verificación no está aprobada",
  skip_no_kyc_applicant: "Su verificación no está vinculada",
  skip_missing_identity_fields: "Le falta el apellido o la fecha de nacimiento",
  skip_missing_client_email: "La organización no tiene su correo",
  skip_limit_reached: "Quedó por fuera del límite de este envío",
  skip_concurrent_conflict: "Otro envío lo tomó al mismo tiempo",
  skip_error: "No se pudo encolar",
  skip_changed: "Su estado cambió; actualiza el tablero",

  kyc_PENDING: "pendiente",
  kyc_IN_REVIEW: "en revisión",
  kyc_VERIFIED: "aprobada",
  kyc_REJECTED: "rechazada",
  kyc_EXPIRED: "vencida",
  no_kyc: "Sin verificación",

  send_title: "Enviar a {{provider}}",
  send_description: "Primero revisamos quiénes pueden enviarse; nada sale hasta que confirmes.",
  send_checking: "Revisando a quiénes se puede enviar…",
  send_ready: "Listos para enviar: {{count}}.",
  send_queue_note:
    "Se registran en {{provider}} uno a uno, en la misma fila que las tarjetas nuevas, así que su estado cambia en unos minutos.",
  send_none: "Ninguno se puede enviar todavía.",
  send_paused_note: "Estaban en pausa: {{count}}. Si no se corrigió el motivo, se volverán a pausar.",
  send_skipped_heading: "No se envían ({{count}}):",
  send_confirm: "Enviar ({{count}})",
  send_recheck: "Volver a revisar",
  send_done_heading: "Enviados",
  send_done_counts: "Por primera vez: {{queued}}. Reanudados: {{resumed}}.",
  send_done_skipped: "Quedaron por fuera al enviar: {{count}}. Vuelve a revisarlos en el tablero.",
  send_done_note: "Actualiza el tablero en unos minutos para ver su avance en {{provider}}.",

  link_title: "Vincular verificación",
  link_description: "Busca la verificación de identidad de {{name}} y la vincula a su registro.",
  link_searching: "Buscando su verificación…",
  link_found: "Encontramos una verificación de esta persona.",
  link_match_by: "Coincide por {{field}}",
  match_external_user_id: "su registro en Coloca",
  match_document_number: "número de documento",
  match_birthdate_name: "nombre y fecha de nacimiento",
  match_email: "correo",
  match_manual: "vinculación manual",
  link_confirm: "Vincular",
  link_done: "Verificación vinculada.",
  link_done_verified: "Verificación vinculada y aprobada. Ya puedes enviarlo a {{provider}}.",
  link_other_identity: "Esa verificación es de otra persona registrada en Coloca; aquí no se vincula.",
  link_linked_elsewhere:
    "La verificación terminó vinculada a otra persona registrada en Coloca, no a esta. Revísalo con cumplimiento.",
  link_category_linked: "Verificación vinculada.",
  link_category_linkable: "La verificación se puede vincular.",
  link_category_superseded: "Hay otra verificación aprobada más reciente de esta persona.",
  link_category_match_unverified:
    "Hay una verificación con el mismo correo, pero ni el documento ni la fecha de nacimiento coinciden; no se vincula sola.",
  link_category_ambiguous: "La verificación coincide con más de una persona; revísala con cumplimiento.",
  link_category_foreign_external_id: "La verificación está a nombre de otra identidad.",
  link_category_already_linked: "Ya tiene una verificación vinculada; revisa su estado.",
  link_category_other_provider: "Su verificación se hizo con otro servicio de identidad.",
  link_category_no_applicant: "No encontramos una verificación hecha desde Coloca para esta persona.",
  link_category_orphan: "La verificación no coincide con nadie registrado en Coloca.",
  link_category_applicant_not_found: "No existe una verificación con ese ID.",
  link_category_error: "No pudimos consultar la verificación.",
  link_manual_label: "¿Tienes el ID de la verificación?",
  link_manual_placeholder: "ID de la verificación",
  link_manual_search: "Buscar",
  link_manual_hint:
    "Para verificaciones hechas fuera de Coloca. Solo se vincula si coincide el documento, o el nombre y la fecha de nacimiento.",
  link_manual_invalid: "Revisa el ID: solo letras, números, guiones y guion bajo, de 6 a 64 caracteres.",
  link_org_identity_hint:
    "Es la identidad de la propia organización. Si su verificación se hizo fuera de Coloca, vincúlala desde Verificación de cuentas.",
  link_org_identity_open: "Ir a Verificación de cuentas",

  sync_title: "Revisar verificación",
  sync_description: "Compara el estado de la verificación de {{name}} con el que tenemos guardado.",
  sync_checking: "Comparando con la verificación…",
  sync_mismatch: "La verificación figura {{remote}}, pero aquí está {{local}}.",
  sync_in_sync: "Aquí y en la verificación figura {{status}}; no hay nada que actualizar.",
  sync_not_reviewed: "La verificación todavía no ha sido revisada.",
  sync_no_reference: "No tiene una verificación vinculada.",
  sync_applicant_not_found:
    "La verificación vinculada ya no existe y no hay otra aprobada para usar; revísalo con el equipo técnico.",
  sync_other_provider: "Su verificación se hizo con otro servicio de identidad.",
  sync_green_sibling: "Esta persona tiene otra verificación aprobada; puedes usarla en lugar de la actual.",
  sync_apply: "Pasar a {{status}}",
  sync_repoint: "Usar la verificación aprobada",
  sync_recheck: "Volver a revisar",
  sync_updated: "Estado actualizado: {{status}}.",
  sync_repointed: "Ahora usa la verificación aprobada.",

  data_title: "Qué falta",
  data_missing_identity_fields:
    "A {{name}} le falta el apellido o la fecha de nacimiento, y sin eso no se puede registrar. Complétalos en su ficha de cliente y vuelve a enviarlo.",
  data_missing_email:
    "La organización no tiene un correo de {{name}}. Agrégalo en su ficha de cliente y vuelve a enviarlo.",
  data_ok: "Entendido",

  retry_title: "Reintentar registro",
  retry_description:
    "Vuelve a registrar a {{name}} con los datos que ya tiene guardados. Si sale bien, sigue con la verificación y luego con {{provider}}.",
  retry_done: "Registro completado: {{name}}.",

  detail_verification: "Verificación",
  detail_card: "En {{provider}}",
  detail_email: "Correo de contacto",
  detail_country: "País",
  detail_updated: "Último cambio en el emisor",
  detail_created: "Creado",
  detail_identity_id: "ID de la identidad",
};
